<template>
  <NativeAdCardLarge
    v-if="showAdUnit"
    :width="getOptionValue(LayoutWidth)"
    :height="getOptionValue(LayoutHeight)"
    :entity="adEntity"
  />
</template>

<script>
import { DynamicElementMixin } from "%/dynamic-components/render-engine/mixins/production/dynamic-element-mixin";
import NativeAdCardLarge from "@/smart-feed/components/native-ad/layouts/NativeAdCardLarge.vue";
import { mapActions, mapState } from "pinia";
import { usePublicationAdsStore } from "%/stores/publication-ads-store";
import { useFanPublicationStore } from "%/stores/fan-publication-store";
import BaseOption from "%/dynamic-components/render-engine/classes/base-option";
import LayoutHeight from "%/dynamic-components/render-engine/options/layout-options/layout-height";
import LayoutWidth from "%/dynamic-components/render-engine/options/layout-options/layout-width";
import AppearanceOptions from "%/dynamic-components/render-engine/bundles/appearance-options";
import LayoutWidthHeightOptions from "%/dynamic-components/render-engine/bundles/layout-width-height-options";

export default {
  name: "AdUnit",
  components: { NativeAdCardLarge },
  mixins: [DynamicElementMixin],
  data() {
    return {
      BaseOption,
      LayoutHeight,
      LayoutWidth,
    };
  },
  optionBundles: [
    AppearanceOptions,
    new LayoutWidthHeightOptions({
      "default.layout-width": "fill",
    }, {
      "max-height": true,
      "min-height": true,
      "min-width": true,
      "max-width": true,
    }),
  ],
  elementPanelSettings: {
    displayName: "Ad Unit",
    displayIcon: "money-bill",
    elementGroup: "general",
    elementType: "element",
  },
  computed: {
    ...mapState(usePublicationAdsStore, ["randomAd"]),
    ...mapState(useFanPublicationStore, ["publicationId", "publicationData"]),
    isAdsEnabled() {
      return this.publicationData.enable_ads === 1;
    },
    adEntity() {
      return this.randomAd;
    },
    showAdUnit() {
      if (this.editMode && this.adEntity) {
        return true;
      } else if (this.isAdsEnabled && this.adEntity) {
        return true;
      }
      return false;
    },
  },
  mounted() {
    this.fetchRandomAd(this.publicationId);
  },
  methods: {
    ...mapActions(usePublicationAdsStore, ["fetchRandomAd"]),
  },
};
</script>

<style scoped lang="scss"></style>
